import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { maxWidthLayoutStyles } from '../../utils/styleHelpers.js';
import { jsx } from 'react/jsx-runtime';
export { PageHeader } from './pageHeader.js';
export { PageFooter } from './pageFooter.js';

var _templateObject, _templateObject2, _templateObject3;
const Page = /*#__PURE__*/styled.div.withConfig({
  displayName: "page__Page",
  componentId: "sc-14gzlcj-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  isolation: isolate;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background-color: ", ";\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.colors.background;
});
const PageMainContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "page__PageMainContainer",
  componentId: "sc-14gzlcj-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  padding: ", ";\n\n  &:focus-visible {\n    box-shadow: none;\n  }\n\n  ", " {\n    padding: ", ";\n  }\n"])), _ref2 => {
  let {
    theme,
    fullWidth
  } = _ref2;
  return !fullWidth && theme.spacing.threeQuarterSpacing;
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.mediaQueries.md;
}, _ref4 => {
  let {
    theme,
    fullWidth
  } = _ref4;
  return !fullWidth && theme.spacing.doubleSpacing;
});
const PageMainInner = /*#__PURE__*/styled.div.withConfig({
  displayName: "page__PageMainInner",
  componentId: "sc-14gzlcj-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  min-height: 100%;\n  ", "\n"])), maxWidthLayoutStyles);
const PageMain = /*#__PURE__*/forwardRef(function PageMain(_ref5, ref) {
  let {
    children,
    fullWidth,
    ...rest
  } = _ref5;
  return /*#__PURE__*/jsx(PageMainContainer, {
    fullWidth: fullWidth,
    ref: ref,
    ...rest,
    tabIndex: "-1",
    children: fullWidth ? children : /*#__PURE__*/jsx(PageMainInner, {
      children: children
    })
  });
});

export { Page, PageMain };
